import { render } from "./RegistroLecheProcesada.vue?vue&type=template&id=037d14a8"
import script from "./RegistroLecheProcesada.vue?vue&type=script&lang=js"
export * from "./RegistroLecheProcesada.vue?vue&type=script&lang=js"

import "./RegistroLecheProcesada.vue?vue&type=style&index=0&id=037d14a8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__